import React from 'react';
import { Box } from '@chakra-ui/react';
import { useOutletContext } from 'react-router-dom';
import type { QuestionnaireContext } from 'client_react/questionnaire/QuestionnaireApp';

const QuestionnaireContent: React.FC = () => {
    const { questionnaire } = useOutletContext<QuestionnaireContext>();

    // TODO: Render the questionnaire content here

    return (
        <Box
            as="pre"
            textAlign="left"
            p={4}
            bg="gray.50"
            borderRadius="md"
            overflow="auto"
            fontSize="sm"
        >
            {JSON.stringify(questionnaire, null, 2)}
        </Box>
    );
};

export default QuestionnaireContent;
